@file:OptIn(InternalResourceApi::class)

package com.flowyride.feature.planner.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.flowyride.feature.planner.resources/"

@delegate:ResourceContentHash(-925_135_252)
internal val Res.string.place_placeholder: StringResource by lazy {
      StringResource("string:place_placeholder", "place_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5365, 57),
      ))
    }

@delegate:ResourceContentHash(56_200_336)
internal val Res.string.place_saved: StringResource by lazy {
      StringResource("string:place_saved", "place_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5423, 47),
      ))
    }

@delegate:ResourceContentHash(-1_467_212_253)
internal val Res.string.preferences_hint_fixed_profile: StringResource by lazy {
      StringResource("string:preferences_hint_fixed_profile", "preferences_hint_fixed_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5471, 118),
      ))
    }

@delegate:ResourceContentHash(-267_023_112)
internal val Res.string.redo: StringResource by lazy {
      StringResource("string:redo", "redo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5590, 48),
      ))
    }

@delegate:ResourceContentHash(-981_801_054)
internal val Res.string.remove_stop: StringResource by lazy {
      StringResource("string:remove_stop", "remove_stop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5639, 31),
      ))
    }

@delegate:ResourceContentHash(-576_623_258)
internal val Res.string.replace_confirm: StringResource by lazy {
      StringResource("string:replace_confirm", "replace_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5671, 35),
      ))
    }

@delegate:ResourceContentHash(840_548_379)
internal val Res.string.replace_message: StringResource by lazy {
      StringResource("string:replace_message", "replace_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5707, 71),
      ))
    }

@delegate:ResourceContentHash(-1_226_023_271)
internal val Res.string.replace_title: StringResource by lazy {
      StringResource("string:replace_title", "replace_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5779, 57),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
internal val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5837, 29),
      ))
    }

@delegate:ResourceContentHash(-631_657_983)
internal val Res.string.reverse_stops: StringResource by lazy {
      StringResource("string:reverse_stops", "reverse_stops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5867, 33),
      ))
    }

@delegate:ResourceContentHash(-1_060_208_400)
internal val Res.string.route_engine_credit: StringResource by lazy {
      StringResource("string:route_engine_credit", "route_engine_credit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5901, 39),
      ))
    }

@delegate:ResourceContentHash(-2_040_443_266)
internal val Res.string.route_idle: StringResource by lazy {
      StringResource("string:route_idle", "route_idle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5941, 78),
      ))
    }

@delegate:ResourceContentHash(-1_953_075_120)
internal val Res.string.route_loading: StringResource by lazy {
      StringResource("string:route_loading", "route_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6020, 57),
      ))
    }

@delegate:ResourceContentHash(-725_192_519)
internal val Res.string.route_summary: StringResource by lazy {
      StringResource("string:route_summary", "route_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6078, 37),
      ))
    }

@delegate:ResourceContentHash(147_048_712)
internal val Res.string.save_place: StringResource by lazy {
      StringResource("string:save_place", "save_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6116, 46),
      ))
    }

@delegate:ResourceContentHash(-1_453_121_680)
internal val Res.string.search_destination: StringResource by lazy {
      StringResource("string:search_destination", "search_destination", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6163, 46),
      ))
    }

@delegate:ResourceContentHash(-534_489_822)
internal val Res.string.show_speed_cameras: StringResource by lazy {
      StringResource("string:show_speed_cameras", "show_speed_cameras", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6210, 62),
      ))
    }

@delegate:ResourceContentHash(-667_947_909)
internal val Res.string.speed_band_fast: StringResource by lazy {
      StringResource("string:speed_band_fast", "speed_band_fast", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6273, 35),
      ))
    }

@delegate:ResourceContentHash(-1_860_736_599)
internal val Res.string.speed_band_road: StringResource by lazy {
      StringResource("string:speed_band_road", "speed_band_road", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6309, 31),
      ))
    }

@delegate:ResourceContentHash(56_828_599)
internal val Res.string.speed_band_slow: StringResource by lazy {
      StringResource("string:speed_band_slow", "speed_band_slow", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6341, 31),
      ))
    }

@delegate:ResourceContentHash(-2_112_299_536)
internal val Res.string.speed_band_town: StringResource by lazy {
      StringResource("string:speed_band_town", "speed_band_town", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6373, 39),
      ))
    }

@delegate:ResourceContentHash(-171_055_210)
internal val Res.string.speed_band_unknown: StringResource by lazy {
      StringResource("string:speed_band_unknown", "speed_band_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6413, 38),
      ))
    }

@delegate:ResourceContentHash(870_428_685)
internal val Res.string.speed_camera_alerts: StringResource by lazy {
      StringResource("string:speed_camera_alerts", "speed_camera_alerts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6857, 75),
      ))
    }

@delegate:ResourceContentHash(1_867_404_917)
internal val Res.string.speed_camera_alerts_enable: StringResource by lazy {
      StringResource("string:speed_camera_alerts_enable", "speed_camera_alerts_enable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6452, 46),
      ))
    }

@delegate:ResourceContentHash(1_750_935_361)
internal val Res.string.speed_camera_alerts_title: StringResource by lazy {
      StringResource("string:speed_camera_alerts_title", "speed_camera_alerts_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6499, 65),
      ))
    }

@delegate:ResourceContentHash(800_642_861)
internal val Res.string.speed_camera_alerts_warning: StringResource by lazy {
      StringResource("string:speed_camera_alerts_warning", "speed_camera_alerts_warning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6565, 291),
      ))
    }

@delegate:ResourceContentHash(-744_989_001)
internal val Res.string.speed_camera_limit: StringResource by lazy {
      StringResource("string:speed_camera_limit", "speed_camera_limit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7012, 62),
      ))
    }

@delegate:ResourceContentHash(-1_295_231_831)
internal val Res.string.speed_camera_limit_unknown: StringResource by lazy {
      StringResource("string:speed_camera_limit_unknown", "speed_camera_limit_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6933, 78),
      ))
    }

@delegate:ResourceContentHash(-856_863_060)
internal val Res.string.speed_camera_type_discriminating: StringResource by lazy {
      StringResource("string:speed_camera_type_discriminating", "speed_camera_type_discriminating", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7075, 112),
      ))
    }

@delegate:ResourceContentHash(-1_918_834_388)
internal val Res.string.speed_camera_type_fixed: StringResource by lazy {
      StringResource("string:speed_camera_type_fixed", "speed_camera_type_fixed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7188, 47),
      ))
    }

@delegate:ResourceContentHash(1_640_998_680)
internal val Res.string.speed_camera_type_level_crossing: StringResource by lazy {
      StringResource("string:speed_camera_type_level_crossing", "speed_camera_type_level_crossing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7236, 76),
      ))
    }

@delegate:ResourceContentHash(-890_536_819)
internal val Res.string.speed_camera_type_red_light: StringResource by lazy {
      StringResource("string:speed_camera_type_red_light", "speed_camera_type_red_light", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7313, 59),
      ))
    }

@delegate:ResourceContentHash(-690_823_936)
internal val Res.string.speed_camera_type_section: StringResource by lazy {
      StringResource("string:speed_camera_type_section", "speed_camera_type_section", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7373, 81),
      ))
    }

@delegate:ResourceContentHash(-51_882_199)
internal val Res.string.speed_camera_type_tower: StringResource by lazy {
      StringResource("string:speed_camera_type_tower", "speed_camera_type_tower", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7455, 51),
      ))
    }

@delegate:ResourceContentHash(-2_125_727_856)
internal val Res.string.speed_camera_type_unknown: StringResource by lazy {
      StringResource("string:speed_camera_type_unknown", "speed_camera_type_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7507, 41),
      ))
    }

@delegate:ResourceContentHash(242_191_924)
internal val Res.string.speed_camera_type_urban: StringResource by lazy {
      StringResource("string:speed_camera_type_urban", "speed_camera_type_urban", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7549, 47),
      ))
    }

@delegate:ResourceContentHash(711_972_945)
internal val Res.string.speed_limits_fetch: StringResource by lazy {
      StringResource("string:speed_limits_fetch", "speed_limits_fetch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7667, 82),
      ))
    }

@delegate:ResourceContentHash(795_146_522)
internal val Res.string.speed_limits_fetching: StringResource by lazy {
      StringResource("string:speed_limits_fetching", "speed_limits_fetching", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7597, 69),
      ))
    }

@delegate:ResourceContentHash(-1_575_117_607)
internal val Res.string.speed_limits_none: StringResource by lazy {
      StringResource("string:speed_limits_none", "speed_limits_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7750, 77),
      ))
    }

@delegate:ResourceContentHash(-1_880_038_192)
internal val Res.string.stop_label: StringResource by lazy {
      StringResource("string:stop_label", "stop_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7828, 34),
      ))
    }

@delegate:ResourceContentHash(-484_915_998)
internal val Res.string.stop_options: StringResource by lazy {
      StringResource("string:stop_options", "stop_options", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7863, 48),
      ))
    }

@delegate:ResourceContentHash(599_858_705)
internal val Res.string.stops_summary: StringResource by lazy {
      StringResource("string:stops_summary", "stops_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7912, 41),
      ))
    }

@delegate:ResourceContentHash(113_068_406)
internal val Res.string.undo: StringResource by lazy {
      StringResource("string:undo", "undo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7954, 56),
      ))
    }

@delegate:ResourceContentHash(-424_810_786)
internal val Res.string.windingness_label: StringResource by lazy {
      StringResource("string:windingness_label", "windingness_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8011, 37),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("place_placeholder", Res.string.place_placeholder)
  map.put("place_saved", Res.string.place_saved)
  map.put("preferences_hint_fixed_profile", Res.string.preferences_hint_fixed_profile)
  map.put("redo", Res.string.redo)
  map.put("remove_stop", Res.string.remove_stop)
  map.put("replace_confirm", Res.string.replace_confirm)
  map.put("replace_message", Res.string.replace_message)
  map.put("replace_title", Res.string.replace_title)
  map.put("retry", Res.string.retry)
  map.put("reverse_stops", Res.string.reverse_stops)
  map.put("route_engine_credit", Res.string.route_engine_credit)
  map.put("route_idle", Res.string.route_idle)
  map.put("route_loading", Res.string.route_loading)
  map.put("route_summary", Res.string.route_summary)
  map.put("save_place", Res.string.save_place)
  map.put("search_destination", Res.string.search_destination)
  map.put("show_speed_cameras", Res.string.show_speed_cameras)
  map.put("speed_band_fast", Res.string.speed_band_fast)
  map.put("speed_band_road", Res.string.speed_band_road)
  map.put("speed_band_slow", Res.string.speed_band_slow)
  map.put("speed_band_town", Res.string.speed_band_town)
  map.put("speed_band_unknown", Res.string.speed_band_unknown)
  map.put("speed_camera_alerts", Res.string.speed_camera_alerts)
  map.put("speed_camera_alerts_enable", Res.string.speed_camera_alerts_enable)
  map.put("speed_camera_alerts_title", Res.string.speed_camera_alerts_title)
  map.put("speed_camera_alerts_warning", Res.string.speed_camera_alerts_warning)
  map.put("speed_camera_limit", Res.string.speed_camera_limit)
  map.put("speed_camera_limit_unknown", Res.string.speed_camera_limit_unknown)
  map.put("speed_camera_type_discriminating", Res.string.speed_camera_type_discriminating)
  map.put("speed_camera_type_fixed", Res.string.speed_camera_type_fixed)
  map.put("speed_camera_type_level_crossing", Res.string.speed_camera_type_level_crossing)
  map.put("speed_camera_type_red_light", Res.string.speed_camera_type_red_light)
  map.put("speed_camera_type_section", Res.string.speed_camera_type_section)
  map.put("speed_camera_type_tower", Res.string.speed_camera_type_tower)
  map.put("speed_camera_type_unknown", Res.string.speed_camera_type_unknown)
  map.put("speed_camera_type_urban", Res.string.speed_camera_type_urban)
  map.put("speed_limits_fetch", Res.string.speed_limits_fetch)
  map.put("speed_limits_fetching", Res.string.speed_limits_fetching)
  map.put("speed_limits_none", Res.string.speed_limits_none)
  map.put("stop_label", Res.string.stop_label)
  map.put("stop_options", Res.string.stop_options)
  map.put("stops_summary", Res.string.stops_summary)
  map.put("undo", Res.string.undo)
  map.put("windingness_label", Res.string.windingness_label)
}
